<div class="navbar-area">
    <div class="wilo-responsive-nav">
        <div class="container">
            <div class="wilo-responsive-menu">
                <div class="logo">
                    <a routerLink="/">
                        <img src="https://imgvid.blob.core.windows.net/imgvid/logo.png" alt="logo"/>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="wilo-nav">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/">
                    <img src="https://imgvid.blob.core.windows.net/imgvid/logo.png" alt="logo"/>
                </a>

                <div class="collapse navbar-collapse mean-menu">
                    <ul class="navbar-nav">
                        <li class="nav-item"><a href="#home" class="nav-link" [ngStyle]="{'color': (router.url === '/#home' || router.url === '/') ? '#c12121' : (router.url.startsWith('/c') ? 'grey':'white')}">Home</a></li>

                        <li class="nav-item"><a href="#solutions" class="nav-link" [ngStyle]="{'color': (router.url === '/#solutions') ? '#c12121' : (router.url.startsWith('/c') ? 'grey':'white')}">Solutions</a></li>

                        <li class="nav-item"><a href="#approach" class="nav-link" [ngStyle]="{'color': (router.url === '/#approach') ? '#c12121' : (router.url.startsWith('/c') ? 'grey':'white')}">Services</a></li>

                        <li class="nav-item"><a href="#industries" class="nav-link" [ngStyle]="{'color': (router.url === '/#industries') ? '#c12121' : (router.url.startsWith('/c') ? 'grey':'white')}">Industries</a></li>

                        <li class="nav-item"><a href="#story" class="nav-link" [ngStyle]="{'color': (router.url === '/#story') ? '#c12121' : (router.url.startsWith('/c') ? 'grey':'white')}">Our Story</a></li>

                        <li class="nav-item"><a routerLink="faq" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" [ngStyle]="{'color': (router.url === '/faq') ? '#c12121' : '#ffffff'}">FAQ</a></li>

                        <li class="nav-item"><a routerLink="contact" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" [ngStyle]="{'color': (router.url === '/contact') ? '#c12121' : '#ffffff'}">Contact Us</a></li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>